module.exports = __webpack_public_path__ + "media/3-star-wish-reveal-first.962bf62a.ogg";